import { fmt, type Stage } from "@h2lca/core";
import { CHART_LAYOUT, css, STAGE_COLOR } from "@/lib/design";

export interface ReportBarRow {
  label: string;
  value: number;
  stage: Stage;
}

/**
 * 보고서용 가로 막대 , 인쇄에 그대로 나가는 인라인 SVG. 글자는 잉크 토큰, 막대는 단계색.
 * 화면 그래프(Recharts)와 달리 상호작용이 없고 viewBox 비율로 폭을 따라간다.
 */
export function ReportBars({ rows }: { rows: ReportBarRow[] }) {
  if (rows.length === 0) return null;
  const max = Math.max(...rows.map((r) => r.value), 0) || 1;
  const plotW = CHART_LAYOUT.reportWidth - CHART_LAYOUT.reportLabelWidth - CHART_LAYOUT.reportValueWidth - CHART_LAYOUT.reportPad * 2;
  const h = rows.length * CHART_LAYOUT.reportRow + CHART_LAYOUT.reportPad * 2;
  return (
    <svg viewBox={`0 0 ${CHART_LAYOUT.reportWidth} ${h}`} role="img" aria-label="배출량 막대그래프">
      {rows.map((r, i) => {
        const y = CHART_LAYOUT.reportPad + i * CHART_LAYOUT.reportRow;
        const w = Math.max(0, (r.value / max) * plotW);
        return (
          <g key={`${r.label}-${i}`}>
            <text x={CHART_LAYOUT.reportLabelWidth - CHART_LAYOUT.reportPad} y={y + CHART_LAYOUT.reportRow / 2} dominantBaseline="middle" textAnchor="end" className="report-bar-label">
              {r.label}
            </text>
            <rect x={CHART_LAYOUT.reportLabelWidth} y={y + CHART_LAYOUT.reportBarPad} width={w} height={CHART_LAYOUT.reportRow - CHART_LAYOUT.reportBarPad * 2} rx={CHART_LAYOUT.reportBarRadius} fill={css(STAGE_COLOR[r.stage].fill)} />
            <text x={CHART_LAYOUT.reportLabelWidth + w + CHART_LAYOUT.reportPad} y={y + CHART_LAYOUT.reportRow / 2} dominantBaseline="middle" className="report-bar-value">
              {fmt(r.value)}
            </text>
          </g>
        );
      })}
    </svg>
  );
}
